import { YStack } from "tamagui";

import { useSendNoriMessage } from "@/api/mutations/conversation";
import { Button, Footer, Heading, Paragraph } from "@/components";

interface PrescriptionNoMatchProps {
  onClose: () => void;
  onTryAgain: () => void;
  error?: string;
}

export const PrescriptionNoMatch = ({
  onClose,
  onTryAgain,
  error,
}: PrescriptionNoMatchProps) => {
  const { sendNoriMessage, isPending } = useSendNoriMessage();

  const handleTalkToDoctor = () => {
    // No medication match so we fall back to the generalist for intake.
    sendNoriMessage(
      "I'd like to talk to a doctor about renewing a prescription",
      {
        onConversationCreation: onClose,
      },
    );
  };

  return (
    <YStack flex={1} gap="$200" padding="$200">
      <YStack gap="$150" flex={1}>
        <Heading size="$xl">No match found...</Heading>
        <Paragraph color="$textSecondary" size="$s">
          {error ?? "We couldn't find a match in our system."}
        </Paragraph>
        <Paragraph color="$textSecondary" size="$s">
          A Curai doctor can review your prescription and help you out.
        </Paragraph>
      </YStack>

      <Footer mode="dialog">
        <Button
          mode="primary"
          constrained
          onPress={handleTalkToDoctor}
          loading={isPending}
          dataTrackingId="prescription-no-match-talk-to-doctor-button"
        >
          Talk to a doctor
        </Button>
        <Button
          mode="tertiary"
          onPress={onTryAgain}
          dataTrackingId="prescription-no-match-try-again-button"
        >
          Try again
        </Button>
      </Footer>
    </YStack>
  );
};
